export function isEngagementRevenueEligible(
    eventDate?: string,
    launchDate?: string
): boolean {
    if (!launchDate) return true;

    const launchTimestamp = Date.parse(launchDate);
    if (Number.isNaN(launchTimestamp)) return true;

    const eventTimestamp = Date.parse(eventDate || "");
    return !Number.isNaN(eventTimestamp) && eventTimestamp >= launchTimestamp;
}

export function filterRevenueEligibleEngagements<T extends { eventDate?: string }>(
    engagements: T[],
    launchDate?: string
): T[] {
    return engagements.filter(engagement =>
        isEngagementRevenueEligible(engagement.eventDate, launchDate)
    );
}

// Apps launched on or before the end of the billing period are billable (at least their
// fixed fee) even with no conversations, so they don't need to be force-included.
export function isApplicationLaunchedBy(launchDate?: string | null, periodEnd?: string): boolean {
    if (!launchDate || !periodEnd) return false;
    const launchTimestamp = Date.parse(launchDate);
    const periodEndTimestamp = Date.parse(periodEnd);
    return !Number.isNaN(launchTimestamp) && !Number.isNaN(periodEndTimestamp) && launchTimestamp <= periodEndTimestamp;
}
